import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const RestrictedPositionRoutes = [
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
            brandId: {
                dynamic: true
            },
        },
        "component": "hmapSettingsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["positions_settings", "restricted_positions"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/restricted-position/restricted-position.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["positions_settings", "restricted_positions"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/restricted-position/restricted-position.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=restricted-position.routes.js.map